import CosmoPrepLogo from '@/assets/branding/cosmoprep/cosmoprep-logo.png';

const colors = {
  // Brand colors
  brand_primary: '#0779FF', // '#e4e7ed', // '#FF5733',
  brand_primary_hover: '#175CD3',
  brand_primary_highlight: '#84CAFF',
  brand_primary_mid: '#1C86FF',
  brand_primary_dark: '#043E80',
  brand_secondary: '#2F6CCE',
  brand_accent_start: '#268EFF',
  brand_accent_end: '#7A62FF',
  brand_accent_light_start: '#EDF5FF',
  brand_accent_light_end: '#ECE7FF',
  brand_complementary_accent: 'rgb(255,150,27)',
  brand_auth_gradient_mid: '#2F6CCE',
  brand_auth_gradient_end: '#043E80',
  brand_auth_warp_mid: '#1C86FF',
};

export default {
  name: 'CosmoPrep',
  isSAML: true,
  allowPersonalCourses: false,
  logo: CosmoPrepLogo,
  colors,
};
